<div class="essential-container">
  <a (click)="goToAccessibility()"><img src="assets/img/logo/essential-logo.png"></a>
</div>


